<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SSN1oD/images/cover.jpeg?1718044968786" alt="This image is the cover for the book The Deviant #1, The Deviant"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Deviant #1, The Deviant
      </h1>
      <p class="bookDescription body article font2">
        <p>SERIES PREMIERE As snow falls over Milwaukee in 1972, a blood-stained Santa Claus commits unimaginable atrocities against young men. Fifty years later, a troubled young writer interviews this so-called "Deviant Killer," who still maintains his innocence from behind bars. And as Christmas approaches once again, the past returns, wielding a sharpened ax. Eisner-winning writer JAMES TYNION IV (W0RLDTR33, THE DEPARTMENT OF TRUTH) and acclaimed artist JOSHUA HIXSON (The Plot, Children of the Woods) unite for a pitch-black holiday horror story.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Tynion IV, Joshua Hixson, Joshua Hixson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f26e26e